import React from 'react'

//
import HubSpotForm from '../../../components/hubspot'
import { FormLayout2 as FormLayoutWithLeftContent, List } from '../../../storybook'
import { parseHtmlStringToJSX } from '@/src/utils/text'

const BlockRequestForm = ({
  data: {
    title,
    description,
    hubSpotForm,
    headingType,
    formPosition,
    bulletPoints,
    bulletPointsText
  }
}) => {
  const listJSX = bulletPointsText ? parseHtmlStringToJSX(bulletPointsText, 'request-form') : null

  return (
    <FormLayoutWithLeftContent
      text={description || ''}
      title={title || ''}
      headingType={headingType || 'h2'}
      formPosition={formPosition || 'center'}
    >
      <FormLayoutWithLeftContent.Content>
        {(!bulletPoints || bulletPoints?.length === 0) && bulletPointsText ? (
          listJSX
        ) : bulletPoints && bulletPoints.length > 0 ? (
          <List
            type="ol"
            items={bulletPoints.map((item) => ({ id: item.id, text: item.content }))}
          />
        ) : null}
      </FormLayoutWithLeftContent.Content>

      <FormLayoutWithLeftContent.Form>
        <HubSpotForm
          formId={hubSpotForm.formId}
          mode="desktop"
          portalId={hubSpotForm.portalId}
          countryRedirect={hubSpotForm.countryRedirect}
          productPageRedirect={hubSpotForm.productPageRedirect}
          jsScript={hubSpotForm.jsScript}
        />
      </FormLayoutWithLeftContent.Form>
    </FormLayoutWithLeftContent>
  )
}

export default BlockRequestForm
